import { type KyInstance } from 'ky';

import {
  IResNotificationsError,
  IResNotificationsOK,
  IResNotificationsUnauthorized,
  ReqNotifications,
} from '@/types/parcel/notifications/notifications.interface';

type Notifications = () => Promise<
  IResNotificationsOK | IResNotificationsError | IResNotificationsUnauthorized
>;

type UpdateNotification = ({
  id,
  enabled,
}: ReqNotifications) => Promise<
  IResNotificationsOK | IResNotificationsError | IResNotificationsUnauthorized
>;

export interface IReqNotifications {
  notifications: Notifications;
  updateNotification: UpdateNotification;
}

export function reqNotifications(http: KyInstance): IReqNotifications {
  const route = 'api/user';

  return {
    notifications: async () => {
      const response = await http.get(`${route}/notifications`);
      return response.json();
    },
    updateNotification: async ({ id, enabled }) => {
      const response = await http.patch(`${route}/notifications/${id}`, { json: { enabled, id } });
      return response.json();
    },
  };
}
